module.exports = __webpack_public_path__ + "assets/img/news (39).f3cc5dc7.png";